var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBusinessMetric = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.209 18.8264H0.621803C0.457732 18.8264 0.300382 18.7612 0.184366 18.6452C0.0683506 18.5292 0.00317383 18.3719 0.00317383 18.2078V0.618086C0.00328138 0.495811 0.0396216 0.376311 0.107605 0.274678C0.175588 0.173045 0.272165 0.0938379 0.385137 0.0470601C0.49811 0.000282369 0.622411 -0.0119676 0.742342 0.0118574C0.862273 0.0356823 0.972454 0.0945136 1.05897 0.180921L18.6466 17.7702C18.7332 17.8567 18.7921 17.967 18.816 18.087C18.8399 18.2071 18.8277 18.3315 18.7808 18.4446C18.734 18.5576 18.6547 18.6543 18.5529 18.7222C18.4511 18.7902 18.3314 18.8265 18.209 18.8264ZM0.625103 0.411463C0.596841 0.411592 0.568858 0.417048 0.542619 0.427548C0.50469 0.442778 0.472258 0.469129 0.449586 0.503137C0.426914 0.537144 0.415064 0.577217 0.415593 0.618086V18.2078C0.415593 18.2625 0.437319 18.3149 0.475991 18.3536C0.514663 18.3923 0.567113 18.414 0.621803 18.414H18.209C18.2499 18.4141 18.2898 18.402 18.3238 18.3794C18.3578 18.3567 18.3843 18.3245 18.3999 18.2867C18.4155 18.249 18.4196 18.2075 18.4116 18.1675C18.4036 18.1274 18.3839 18.0906 18.355 18.0618L0.767388 0.472501C0.749062 0.453194 0.726994 0.437824 0.702531 0.42733C0.678068 0.416835 0.651722 0.411437 0.625103 0.411463Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBusinessMetric);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/business_metric.ab1cbc0404360f44236dba035966a2be.svg";